/* 
Nytt epostfelt som bruker apiet til å gi custom tilbakemeldinger til bruker 
Kontakt: thomas@nettbureau.no ved spørsmål.
*/

import React from "react";
import { utils } from './../utils'

export default function ({ tools, language, validators, InputField }) {
  const EMAIL_REGEX_PATTERN = /@/i;

  function validateEmail({ matches }) {
    return matches(new RegExp(EMAIL_REGEX_PATTERN), language["email-invalid"]);
  }

  function check_if_api_should_run(value) {
    const pattern = new RegExp(EMAIL_REGEX_PATTERN)

    if (pattern.test(value)) {
      return true
    }

    return false
  }

  async function callAip(apiName, params) {
    try {
      if (!check_if_api_should_run(params['q'])) {
        return
      }

      const apiKey = this.props.globalState.globalConfig.apiKey;

      const key = tools.isDev() ? "nO4rMasHdYv7fsEplYHo7reHu0iBxZoCR1EljwkJqcLTHZLT3Q2ofbczZPf75Ma" : apiKey

      const root_url = 'https://leazard.io/api/3'

      const { q } = params

      const url = `${root_url}/${apiName}?key=${key}`

      this.props.field.state.api.running = true;
      this.props.onUpdate()

      const response = await fetch(url, {
        method: 'POST',
        body: JSON.stringify({
          q
        })
      })

      const responseText = await response.text()
      const data = tools.parseJSON(responseText)

      this.props.field.state.api.running = false
      this.props.onUpdate()

      handleApiResponse.bind(this)(data)
    }
    catch (e) {
      this.props.field.state.api.running = false
      this.props.onUpdate()
      throw e
    }
  }

  function handleApiResponse(data) {
    if (this.autosuggestion && this.state.suggestionActedUpon == false) {
      // Avoid out of order response
      if (data.q == this.props.field.state.value) {
        if (data.status == true) {
          this.props.field.state.showWarning = false
          return
        } else {
          if (data.result.autocomplete && data.result.autocomplete[0]) {
            this.props.field.state.showWarning = true
            this.setState({
              alertBoxMessage: data.result.autocomplete[0]
            })
          }
        }
      }
    }
    else if (this.autosuggestion == false || this.state.suggestionActedUpon) {
      if (data.result && data.result.canonical) {
        // Avoid out of order response
        if (data.q == this.props.field.state.value) {
          if (data.status === false) {
            if (data.result.mx && !data.result.smtp) {
              this.props.field.state.showWarning = true
              this.setState({
                alertBoxMessage: language['email_wrong_user_account']
              })
            }
            else {
              this.props.field.state.showWarning = true
              this.setState({
                alertBoxMessage: language['email_wrong_email_address']
              })
            }

            this.props.field.state.showWarning = true
          }
          else {
            this.props.field.state.showWarning = false
          }

          append_additional_state.bind(this)(data)

          this.forceUpdate()
          this.props.onUpdate()
        }
      }
    } else {
      return
    }
  }

  /**
   * Legg til api resultat til state objektet
   * @param {state} dette er response fra api kallet
   */
  function append_additional_state(state) {
    try {
      if (typeof state.result !== 'undefined') {
        const field = this.props.field.config.id + '_'

        const result = state.result
        for (let key in result) {
          this.props.field.state[field + key] = result[key]
        }
      }
    }
    catch (e) {
      console.log(e)
    }
  }

  class EmailNew extends React.Component {
    constructor() {
      super()

      this.state = {
        blurred: false,
        suggestionActedUpon: false,
        alertBoxMessage: '',
      }
    }

    componentDidMount() {
      this.autosuggestion = this.props.field.config.autosuggestion
      this.props.field.state.showWarning = false
    }

    onBlur(event) {
      if (!this.state.blurred) {
        this.setState({ blurred: true })
      }
    }

    onUpdate(event) {
      if (this.state.blurred) {
        this.props.field.state.showWarning = false

        this.setState({
          suggestionActedUpon: false,
          blurred: false,
        })
      }

      const value = event.target.value;

      callAip.bind(this)('email', { q: value, country: 'SE' })

      this.props.field.state.value = value
      this.props.onUpdate()
      this.forceUpdate()
    }

    showAlert() {
      const { blurred } = this.state
      const showWarning = this.props.field.state.showWarning

      if (showWarning && blurred) {
        return true
      }

      return false
    }

    /* Called when user clicks yes to change the email to the autosuggested value */
    onAutosuggestionYes(event) {
      event.preventDefault()

      this.setState({
        suggestionActedUpon: true
      })

      this.props.field.state.value = this.state.alertBoxMessage
      this.props.field.state.showWarning = false

      callAip.bind(this)('email', { q: this.props.field.state.value, country: 'SE' })

      this.forceUpdate()
      this.props.onUpdate()
    }

    /* Called when user clicks no to the autosuggested value */
    onAutosuggestionNo(event) {
      event.preventDefault()

      this.setState({
        suggestionActedUpon: true
      })

      callAip.bind(this)('email', { q: this.props.field.state.value, country: 'SE' })

      this.forceUpdate()
      this.props.onUpdate()
    }

    alertInfoBox() {
      if (this.showAlert()) {
        if (this.autosuggestion == false || this.state.suggestionActedUpon) {
          return (
            <div style={{ marginTop: 1 + 'em' }}>
              <div className="lz-alert" style={{ display: "block" }}>
                {this.state.alertBoxMessage}
              </div>
            </div>
          );
        }
        else if (this.autosuggestion == true && this.state.suggestionActedUpon == false) {
          return (
            <div className="lz-input-suggestion--box">
              <span>{language['email_did_you_mean']} <strong>{this.state.alertBoxMessage}</strong>?</span>
              <div className="lz-input-suggestion-buttons">
                <button onClick={(e) => { this.onAutosuggestionNo.bind(this)(e) }}>Nei</button>
                <button onClick={(e) => { this.onAutosuggestionYes.bind(this)(e) }}>Ja, endre e-post</button>
              </div>
            </div>
          )
        }
      }
    }

    label() {
      const field = this.props.field
      const { config } = field

      if (typeof language[config.label] === 'undefined') {
        return utils.parseLabel(config.label, this.props)
      } else {
        return language[config.label]
      }
    }

    placeholder() {
      const field = this.props.field
      const { config } = field

      if (typeof language[config.placeholder] === 'undefined') {
        return config.placeholder
      } else {
        return language[config.placeholder]
      }
    }

    renderSuggestionClass() {
      if (this.props.field.state.showWarning && this.state.suggestionActedUpon == false && this.autosuggestion && this.state.blurred) {
        return 'lz-input-suggestion'
      }
      else {
        return ''
      }
    }

    renderErrorClass() {
      if (this.props.field.state.showWarning == false) {
        return this.props.errorClass
      } else {
        return ''
      }
    }

    render() {
      const { field } = this.props;
      const { state, config } = field
      const id = tools.uniqueId(config.id)

      return (
        <div className="lz-input-wrapper">
          <label htmlFor={id}>{this.label()}</label>
          <span className="lz-extratext">{config.tinyLabel}</span>
          <div className={`lz-input ${this.renderSuggestionClass()} ${this.renderErrorClass()} ${(config.style && config.style.lz_input) || ""}`}>
            <div className={this.props.spinnerClass} >
              <i className="fa fa-spinner fa-spin"></i>
            </div>

            <div className="lz-checkmark">
              <i className="fa fa-check"></i>
            </div>

            <input id={id} style={{ WebkitUserSelect: 'auto' }} type="email" onBlur={this.onBlur.bind(this)} onChange={this.onUpdate.bind(this)} value={state.value} placeholder={this.placeholder()} />

            <span className="lz-input-bar"></span>

            {this.alertInfoBox()}
          </div>
          {this.props.errors}
        </div>
      );
    }
  }

  return {
    html: EmailNew,
    validators: [
      validators.mandatory(),
      validateEmail(validators)
    ],
    config: {
      validators: ["mandatory"],
      behaviour: "text-input",
    }
  };
};